export default "__VITE_PUBLIC_ASSET__d688ccac__"